import PropTypes from 'prop-types';
import React from 'react';
import StyledButton from './styled-button';

const { forwardRef } = React;

const sizes = ['large', 'medium', 'small'];

const propTypes = {
	children: PropTypes.node,
	disabled: PropTypes.bool,
	dataTestId: PropTypes.string,
	icon: PropTypes.element,
	iconRight: PropTypes.bool,
	fullWidth: PropTypes.bool,
	href: PropTypes.string,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(sizes),
		PropTypes.shape(
			['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(
				(acc, current) => ({ ...acc, [current]: PropTypes.oneOf(sizes) }),
				{},
			),
		),
	]),
	variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
};
const defaultProps = {
	children: null,
	dataTestId: null,
	disabled: false,
	fullWidth: false,
	href: undefined,
	icon: undefined,
	iconRight: false,
	size: 'large',
	variant: 'primary',
};

const Button = forwardRef(({ ...props }, ref) => {
	const { href, ...otherProps } = props;
	const { dataTestId, disabled } = otherProps;

	if (href && href.length > 0 && disabled === false) {
		return (
			<StyledButton className="fuse-button" data-testid={dataTestId} {...props} as="a" ref={ref} />
		);
	}
	return <StyledButton className="fuse-button" data-testid={dataTestId} ref={ref} {...otherProps} />;
});

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
